export const SettingsDivider = () => {
  return <hr className="border-gray-150 dark:border-gray-800" />
}
